import React from 'react';
import { Input, Row, TextParam, UrlParam } from '../../../../../_lib/Form2';
import { useSonTranslation } from '../../../../../translation/useSonTranslation';

type ExternalLinkFormTemplateProperties = {
  urlParam: UrlParam<'url'>;
  nameParam: TextParam<'name'>;
};

export function ExternalLinkFormTemplate({ urlParam, nameParam }: ExternalLinkFormTemplateProperties) {
  const { t } = useSonTranslation('CreatePage');

  return (
    <>
      <Row>
        <Input label={t('PageManagement:views.create-page-general.inputs.url.labelUrl')} param={urlParam} />
      </Row>
      <Row>
        <Input label={t('PageManagement:views.create-page-general.inputs.url.labelShowText')} param={nameParam} />
      </Row>
    </>
  );
}
